import React from 'react';
import Label from '../../../../ui/label';
import Input from '../../../../ui/input';
import { useDispatch } from 'react-redux';
import { setGroupClassification, setOtherSpecification } from '../../../../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice';
import LoadingCategory from '../../../../ui/loading-category';
import ErrorFetch from '../../../../ui/error-fetch-category';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { MdiHomeGroupMinus } from '../../../../../assets/icon/iconify';
import { useMediaQuery } from '../../../../../hooks/common/use-media-query';
import { useIsCompleteProposalAs } from '../../../../../hooks/proposal/use-state-checker-proposal';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import Checkbox from '../../../../ui/checkbox';

export default function ClientInputGroupClassification() {

    const { 
        groupClassification, 
        isLoadingGroupClassification, 
        isErrorGroupClassification, 
        isFetchingGroupClassification 
    } = useQueries();
    const isErrorLoading = 
        isErrorGroupClassification 
        || isLoadingGroupClassification 
        || isFetchingGroupClassification;
    const {
        groupClassification: selectedGroupClassification,
        othersGroupClassificationValue: otherSpecificGC
    } = useProposalTypeData()

    const dispatch = useDispatch();
    const { hasOtherSpecifyGC } = useProposalTypeData();
    const isComplete = useIsCompleteProposalAs();
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const iconSize: number = isDesktop ? 16 : 14;

    const handleGroupClassificationChange = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setGroupClassification(option));
    };

    const handleOtherSpecificationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setOtherSpecification(e.target.value));
    };

    const mappedOptions: SubTypeOption[] =
        groupClassification?.map(item => ({
            id: item.id,
            name: item.name
        })) || [];

    return (
        <div className="">
            <div className="flex space-x-2 items-center mb-1">
                <div className="bg-[#186db233] p-1 rounded">
                    <MdiHomeGroupMinus width={iconSize} height={iconSize} />
                </div>
                <Label
                    label="Group Classification"
                    fontWeight="font-semibold text-gray-800"
                    fontSize="text-xs"
                    requiredText=" *"
                    isRequired={true}
                />
            </div>
            <div className={`grid ${isErrorLoading ? 'grid-cols-1' : 'grid-cols-2'} gap-2`}>
                {isLoadingGroupClassification || isFetchingGroupClassification ? (
                    <LoadingCategory />
                ) : isErrorGroupClassification ? (
                    <ErrorFetch />
                ) : (
                    mappedOptions.map(option => {
                        const isSelected = selectedGroupClassification?.id === option.id;
                        const isDisabled = !isComplete;
                        return (
                            <Checkbox
                                key={option.id}
                                disabled={isDisabled} 
                                option={option} 
                                isSelected={isSelected} 
                                onChange={handleGroupClassificationChange}
                            />
                        );
                    })
                )}
            </div>
            {hasOtherSpecifyGC && (
                <div className="pt-2">
                    <Input
                        type="text"
                        name="email"
                        value={otherSpecificGC ?? ""}
                        isCustomStyle={true}
                        customCss={`${defaultStyle} ${ !otherSpecificGC ? '' : customStyle }`}
                        onChange={handleOtherSpecificationChange}
                        required={true}
                        placeholder="Please specify here"
                    />
                </div>
            )}
        </div>
    );
}